module.exports = __webpack_public_path__ + "a3a0b5b05100c51c2b40f1cf65053e87.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/leaning-t-owl-er-of-pisa.png
// module id = 577
// module chunks = 0